import { 
  globalCss,
  Grid
} from '@nextui-org/react'
import {
  Outlet,
  Routes,
  Route,
  Navigate,
  useNavigate
} from 'react-router-dom'

import { Layout } from './ui/layout';
import { Box } from './ui/layout/box';
import './App.css';
import bkgImg from './ui/resources/GL_bkg.png'

import { Header, Home } from './pages/home';
import Footer from './pages/footer';
import Opportunities from './pages/grants'
import Apply from './pages/grants/apply'
import ApplyConfirm from './pages/grants/confirmation'
import Services from './pages/services'

const globalStyles = globalCss({
  body: { 
    backgroundColor: "#ffffff",
    // backgroundImage: `url(${bkgImg})`,
    // backgroundSize: "100%",
    // backgroundPosition: "top center",
    // backgroundRepeat: "no-repeat",
    // fontFamily: [
    //     'Garet',
    //     '"Helvetica Neue"',
    //     'Arial',
    //     'sans-serif',
    //     '"Apple Color Emoji"',
    //     '"Segoe UI Emoji"',
    //     '"Segoe UI Symbol"',
    // ].join(','),
    lineHeight: "$md"
  }
})

function App() {
  globalStyles()
  
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={
          <Home />
        } />
        <Route path="/opportunities" element={
          <Opportunities />
        } />
        <Route path="/opportunities/apply" element={
            <Apply />
          } />
        <Route path="/opportunities/apply/confirmation" element={
            <ApplyConfirm />
          } />
      </Route>
    </Routes>
  )
}

function AppLayout() {
  return (
    <Layout>
      <Header />
      {/* <Grid.Container css={{justifyContent: "center"}}>
        <Grid xs={12} sm={10} css={{display: "flex", flexDirection: "column"}}>
          <Outlet />
        </Grid>
      </Grid.Container> */}
      <Box
        css={{
          "@lgMin": {
            width: "80%",
            margin: "0 auto"
          }
        }}>
        <Outlet />
      </Box>
      <Footer />
    </Layout>
  )
}

export default App;
